/**
 *
 * DownloadTimes
 *
 */

 import React, { memo, FunctionComponent } from 'react';
 import { StyledDownloadTimes } from './styledComponents';
 import timesIcon from '../../assets/icons/times.png';
 import docIcon from '../../assets/icons/doc.svg';
 
 interface IProps {
   url: string;
 }
 
 const DownloadTimes: FunctionComponent<IProps> = ({ url }) => {
   return (
     <StyledDownloadTimes>
       <div className="d-flex w-100 flex-column align-items-center mt-50">
         <img src={timesIcon} className=" mb-19" alt="" />

         <a
           href={url}
           download={url.substring(url.lastIndexOf('/') + 1)}
           className="txt fs-20 fw-7 txt-accent mb-10 text-center"
         >
           Download Times <img src={docIcon} alt="" />
         </a>
         <div className="txt txt-secondary text-center">
           Please download a file with Times.
         </div>
       </div>
     </StyledDownloadTimes>
   );
 };
 
 export default memo(DownloadTimes);
 